// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__MrWKw","rotate":"Spinner_rotate__3l1-n","path":"Spinner_path__5RD4Y","dash":"Spinner_dash__WKA95"};